import { useToast } from '@chakra-ui/react';
import { useCallback } from 'react';

export const useNotify = () => {
    const toast = useToast();

    return useCallback((status: string, tx?:string) => {
        if(status === 'success')
        return toast({
            title: 'Transaction sent and confirmed',
            description: `https://solana.fm/tx/${tx}?cluster=mainnet-solana`,
            status: 'success',
            duration: 5000,
            isClosable: true,
        });

        if(status === 'error')
            return   toast({
                title: 'Transaction was not sent',
                description: `Something went wrong`,
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
    }, [toast])
}
